import React from 'react'

import {
    Table
} from 'antd'

import moment from 'moment'

class PendingTable extends React.Component {
    render(){

        const columns = [{
            title: 'Name',
            dataIndex: 'name'
        },{
            title: "Date Submitted",
            dataIndex: 'dateSubmitted',
            render: (dateSubmitted) => moment(dateSubmitted).format("YYYY-MM-DD")
        },{
            title: "User",
            dataIndex: 'user',
            render: (user) => {
                return (
                    <div>
                        <div>
                            {user.local.email}
                        </div>
                        <div>
                            {user.details.name}
                        </div>
                        <div>
                            {user.details.companyName}
                        </div>
                    </div>
                )
            } 
        },{
            title: "Actions",
            dataIndex: "_id",
            render: (adId) => {
                return (
                    <a
                        target="_blank"
                        href={`/eezee-ads/${adId}`}
                    >
                        Review
                    </a>
                )
            }
        }]


        return(
            <Table
                loading={this.props.loading}
                columns={columns}
                dataSource={this.props.data}
            />
        )
    }
}

export default PendingTable


// WEBPACK FOOTER //
// ./src/components/eezee-ads/table/pending.js